import { InputLabelProps, TextField } from "@material-ui/core";
import Input, { InputProps } from "@material-ui/core/Input";
import { createStyles, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../styles";

interface Props extends InputProps {
    showCharacterLimit?: boolean;
    className?: string;
    characterLimitSide?: "left" | "right";
    label?: string;
    placeholder?: string;
    helperText?: string;
    error?: boolean;
    inputLabelProps?: InputLabelProps;
}

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
            },
            characterLimit: {
                alignSelf: "flex-end",
            },
            characterLimitLeft: {
                alignSelf: "flex-start",
            },
            characterLimitNear: {
                color: theme.relode.colors.backgroundText.dark,
                fontWeight: "bold",
            },
            lower: {
                fontSize: 12,
                color: theme.relode.colors.backgroundText.main,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                width: "95%",
                margin: theme.spacing(1, 4, 1, 0),
            },
            clear: {
                cursor: "pointer",
                textDecoration: "underline",
            },
        }),
    { name: "TextArea" }
);

export const TextArea = (props: Props) => {
    const classes = useStyles({});
    const [characterLimitMessage, setCharacterLimitMessage] = React.useState(
        ""
    );
    const [characterLimitClasses, setCharacterLimitClasses] = React.useState(
        classes.characterLimit
    );

    const {
        characterLimitSide = "right",
        className: classNameProp,
        error,
        helperText,
        showCharacterLimit,
        placeholder,
        inputLabelProps,
        ...inputProps
    } = props;

    const maxLength = !!inputProps.inputProps
        ? inputProps.inputProps.maxLength
        : undefined;

    React.useEffect(() => {
        const currentValue = inputProps.value || "";
        let remaining = maxLength;
        if (typeof currentValue === "string" && maxLength !== undefined) {
            remaining = maxLength - currentValue.length;
            const msg = `${currentValue.length} / ${maxLength}`;
            setCharacterLimitMessage(msg);
        }
        const c = classnames({
            [classes.characterLimit]: true,
            [classes.characterLimitNear]: remaining < 10 && remaining >= 0,
            [classes.characterLimitLeft]: characterLimitSide === "left",
        });
        setCharacterLimitClasses(c);
    }, [
        maxLength,
        props.value,
        props.showCharacterLimit,
        characterLimitSide,
        inputProps.inputProps,
        inputProps.value,
        classes.characterLimit,
        classes.characterLimitNear,
        classes.characterLimitLeft,
    ]);

    return (
        <div className={classnames(classes.root, classNameProp)}>
            <TextField
                error={error}
                helperText={helperText}
                id={props.id}
                className={classNameProp}
                label={props.label}
                placeholder={placeholder}
                variant="standard"
                InputProps={{
                    ...inputProps,
                    inputProps: {
                        "data-cy": `${
                            inputProps["data-cy"] ?? inputProps.id
                        }-textArea`,
                        maxLength: inputProps?.inputProps?.maxLength,
                    },
                }}
                InputLabelProps={inputLabelProps}
            />

            {showCharacterLimit && maxLength ? (
                <div className={classes.lower}>
                    <div className={characterLimitClasses}>
                        character limit: {characterLimitMessage}
                    </div>
                </div>
            ) : null}
        </div>
    );
};
